import { render, staticRenderFns } from "./clearCourseContent.vue?vue&type=template&id=37273b22"
import script from "./clearCourseContent.vue?vue&type=script&lang=js"
export * from "./clearCourseContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports